import React from 'react';
import { Chip, useTheme } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useReva } from '../../contexts/RevaContext';

interface RevaAskChipProps {
  /** The question sent to Reva when tapped. */
  question: string;
  label?: string;
}

/**
 * Inline "Ask Reva" affordance for activity cards. Opens Reva with a question
 * already grounded in the thing the card is about. Styled like the dashboard's
 * tinted summary chips (see NaturalLanguageSearch).
 */
const RevaAskChip: React.FC<RevaAskChipProps> = ({
  question,
  label = 'Ask Reva',
}) => {
  const theme = useTheme();
  const { openReva, available } = useReva();
  if (!available) return null;

  return (
    <Chip
      size="small"
      icon={<AutoAwesomeIcon sx={{ fontSize: 14 }} />}
      label={label}
      clickable
      onClick={(e) => {
        e.stopPropagation();
        openReva({ question });
      }}
      sx={{
        height: 26,
        fontSize: '0.85rem',
        fontWeight: 600,
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main + '12',
        '& .MuiChip-label': { px: 1.5 },
        '& .MuiChip-icon': { color: theme.palette.primary.main, ml: 1 },
        '&:hover': { backgroundColor: theme.palette.primary.main + '24' },
      }}
    />
  );
};

export default RevaAskChip;
